
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/catalog",
      function () {
        return require("private-next-pages/course/catalog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course/catalog"])
      });
    }
  